import { render, staticRenderFns } from "./IncomeCostDetail.vue?vue&type=template&id=535ff613&scoped=true&"
import script from "./IncomeCostDetail.vue?vue&type=script&lang=js&"
export * from "./IncomeCostDetail.vue?vue&type=script&lang=js&"
import style0 from "./IncomeCostDetail.vue?vue&type=style&index=0&id=535ff613&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535ff613",
  null
  
)

export default component.exports